<script lang="ts" setup>
import type { FieldData } from '~~/server/api/forms/form'

export interface FormKitCustomButtonProps {
    data: FieldData
    loading: boolean
}
const props = defineProps<FormKitCustomButtonProps>()
</script>
<template>
  <VButton
    type="submit"
    color="primary"
    class="w-100"
    :loading="props.loading"
    :class="{
      'mb-6': !props.data.help,
    }"
  >
    {{ props.data.label }}
  </VButton>
  <div
    v-if="props.data.help"
    class="formkit-help mb-6"
  >
    {{ props.data.help }}
  </div>
</template>
